module.exports = __webpack_public_path__ + "static/img/NSW-39.e30ba33.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/NSW-39.jpg
// module id = yfuy
// module chunks = 0